<template>
  <div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      style="backdrop-filter: blur(6px)"
      id="AggModalPolizaContable"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 100%"
        >
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h3 class="text-success font-weight-bold">
                AGREGAR PÓLIZA CONTABLE &nbsp;&nbsp;
                <i class="fas fa-balance-scale fa-2x"></i>
              </h3>
              <div style="border-radius: 10px" class="row">
                <div class="col-12 text-dark">
                  <CuentaContableSelectComponent
                    :propname="'cuenta_contable'"
                    :label="'Cuenta Contable'"
                    :current="current"
                  />
                </div>
                <div class="col-4 text-dark">
                  <CentroCostoSelectComponent :current="currentContable" />
                </div>
                <div class="col-4 text-dark">
                  <label>Cant. cargo</label>
                  <input
                    placeholder="Q cant. cargo"
                    v-model="currentContable.cargo"
                    type="text"
                    class="form-control"
                  />
                  <small
                    class="text-danger"
                    v-if="
                      currentContable.errors && currentContable.errors.cargo
                    "
                    >{{ currentContable.errors.cargo }}</small
                  >
                </div>
                <div class="col-4 text-dark">
                  <label>Cant. abono</label>
                  <input
                    placeholder="Q cant. abono"
                    v-model="currentContable.abono"
                    type="text"
                    class="form-control"
                  />
                  <small
                    class="text-danger"
                    v-if="
                      currentContable.errors && currentContable.errors.abono
                    "
                    >{{ currentContable.errors.abono }}</small
                  >
                </div>
                <div class="col-12">
                  <br />
                  <button
                    class="btn btn-lg btn-outline-success btn-block"
                    @click="AgregarPolizaContable()"
                  >
                  <i class="far fa-save"></i>  Agregar Póliza
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import CentroCostoSelectComponent from "@/components/commons/CentroCostoSelectComponent";

export default {
  props: ["current_"],
  components: {
    UsuarioEnTablaComponent,
    TiendaSelectComponent,
    CuentaContableSelectComponent,
    CentroCostoSelectComponent,
  },
  data() {
    return {
      current: {
        cuenta_contable: "",
      },
      currentContable: {
        cuenta_contable: "",
        centro_cost: "",
        cargo: 0,
        abono: 0,
        errors: [],
      },
      current_filter: {},
      dataTabla: [],
      mostrarRefresh: false,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    cleanCurrentDefault() {
      let self = this;
      self.current = {
        cuenta_contable: "",
      };
      self.currentContable = {
        cuenta_contable: "",
        centro_cost: "",
        cargo: 0,
        abono: 0,
        errors: [],
      };
    },
    AgregarPolizaContable() {
      let self = this;
      if (self.current.cuenta_contable) {
        self.currentContable.cuenta_contable = self.current.cuenta_contable.id;
      }
      DynamicService.postAction(
        "cxp",
        "cargos",
        self.current_.id,
        "agregar_contabilizacion",
        self.currentContable
      )
        .then((res) => {
          self.cleanCurrentDefault();
          Notifications.toast.success(
            "Agregar póliza contable",
            "Generado correctamente"
          );
          $("#AggModalPolizaContable").modal("hide");
          self.$emit("refreshCargo");
        })
        .catch((err) => {
          self.currentContable.errors = err.response.data;
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Agregar póliza contable",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>
